/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The conversion runs entirely in your browser; nothing is uploaded.`)
};

const es_tb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La conversión se ejecuta completamente en tu navegador; nada se carga.`)
};

const de_tb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Die Umwandlung läuft vollständig in deinem Browser; nichts wird hochgeladen.`)
};

const nl_tb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. De conversie wordt volledig in uw browser uitgevoerd; niets wordt geüpload.`)
};

const fr_tb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. La conversion s'exécute entièrement dans votre navigateur; rien n'est envoyé.`)
};

const it_tb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La conversione funziona completamente nel tuo browser; non viene caricato nulla.`)
};

const pt_br2_tb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A conversão funciona inteiramente no seu navegador; nada é enviado.`)
};

const pt_tb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A conversão corre inteiramente no seu navegador; nada é enviado.`)
};

const ja_tb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。変換はブラウザ内で完全に実行されます。何もアップロードされません。`)
};

const zh_tb_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。转换完全在您的浏览器中进行,不会上传任何内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tb_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tb_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tb_faq3_a", locale)
	if (locale === "en") return en_tb_faq3_a(inputs)
	if (locale === "es") return es_tb_faq3_a(inputs)
	if (locale === "de") return de_tb_faq3_a(inputs)
	if (locale === "nl") return nl_tb_faq3_a(inputs)
	if (locale === "fr") return fr_tb_faq3_a(inputs)
	if (locale === "it") return it_tb_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_tb_faq3_a(inputs)
	if (locale === "pt") return pt_tb_faq3_a(inputs)
	if (locale === "ja") return ja_tb_faq3_a(inputs)
	return zh_tb_faq3_a(inputs)
};